export const GET_THEME = 'posControle/auth/GET_THEME'

export function getTheme(theme) {
    return {
        type: GET_THEME,
        theme
    }
}